"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormInvalid = void 0;
var _react = require("react");
var _lodash = require("lodash");
/**
 * Form is invalid if:
 * - Form is still validating asynchronously OR
 * - Not all required fields have values OR
 * - Not all required fields without values have been touched OR
 * - Some fields have errors
 * @param form
 * @returns {boolean} true if invalid, false otherwise
 */
var useFormInvalid = function useFormInvalid(form) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    submitIsHiddenUntilFormTouched: false
  };
  var getFieldsError = form.getFieldsError,
    isFieldTouched = form.isFieldTouched,
    isFieldsTouched = form.isFieldsTouched,
    getFieldProps = form.getFieldProps,
    getFieldValue = form.getFieldValue,
    isFieldsValidating = form.isFieldsValidating;
  var formErrors = getFieldsError();

  // Form object will not contain validation errors until validateFields is called
  (0, _react.useEffect)(function () {
    if (options.submitIsHiddenUntilFormTouched && isFieldsTouched()) {
      form.validateFields();
    }
  }, [isFieldsTouched]);
  (0, _react.useEffect)(function () {
    if (!options.submitIsHiddenUntilFormTouched) {
      form.validateFields();
    }
  }, []);

  // Check if every required field has been touched or was given an initial value
  var requiredFieldsTouched = (0, _react.useMemo)(function () {
    return (0, _lodash.keys)(formErrors).every(function (requiredField) {
      var rules = getFieldProps(requiredField)['data-__meta'].rules;
      var hasValue = !!getFieldValue(requiredField);
      var isRequired = rules === null || rules === void 0 ? void 0 : rules.find(function (r) {
        return r.required;
      });
      var fieldTouched = isFieldTouched(requiredField);
      return hasValue || !isRequired || isRequired && fieldTouched;
    });
  }, [formErrors]);

  // Check if every required field has a value
  var requiredFieldsHaveValues = (0, _react.useMemo)(function () {
    return (0, _lodash.keys)(formErrors).every(function (requiredField) {
      var rules = getFieldProps(requiredField)['data-__meta'].rules;
      var fieldValue = getFieldValue(requiredField);
      var isRequired = rules === null || rules === void 0 ? void 0 : rules.find(function (r) {
        return r.required;
      });
      return !isRequired || !!fieldValue;
    });
  }, [formErrors]);
  return isFieldsValidating() || !requiredFieldsHaveValues || !requiredFieldsTouched || (0, _lodash.values)(formErrors).some(function (v) {
    return !!v;
  });
};
exports.useFormInvalid = useFormInvalid;